var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconForward = function SvgIconForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22 0C.693 2.817.435 7.114 6.44 6.97V3.5l5.162 5.25L6.44 14v-3.396C-.752 10.794-1.553 4.148 2.22 0Z",
    fill: "silver"
  })));
};
export { SvgIconForward as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMjIwNjcgMEMwLjY5MTc4MyAyLjgxNjg0IDAuNDM0MTggNy4xMTM1MyA2LjQ0MDAyIDYuOTcwMjVWMy41TDExLjYwMjMgOC43NUw2LjQ0MDAyIDE0VjEwLjYwNDNDLTAuNzUxNjYyIDEwLjc5NDkgLTEuNTUzMDUgNC4xNDgyNCAyLjIyMDY3IDBaIiBmaWxsPSIjQzBDMEMwIi8+Cjwvc3ZnPgo=";